export enum UserRole {
  Admin = 'Admin',
  Regular = 'Regular',
}

export enum SystemPortal {
  Locality = 'locality',
  ServiceStation = 'service-station',
  Storage = 'storage',
  System = 'system',
  ClientAdmin = 'client-admin',
}

export enum CustomerAccessLevel {
  Admin = 'customer_admin',
  User = 'customer_user',
}

export enum FileType {
  Image = 'image',
  File = 'file',
}

export enum NoteColor {
  DarkRed = 'DarkRed',
  DarkOrange = 'DarkOrange',
  DarkYellow = 'DarkYellow',
  DarkGreen = 'DarkGreen',
  DarkTeal = 'DarkTeal',
  DarkBlue = 'DarkBlue',
  DarkNavy = 'DarkNavy',
  DarkPurple = 'DarkPurple',
  LightRed = 'LightRed',
  LightOrange = 'LightOrange',
  LightYellow = 'LightYellow',
  LightGreen = 'LightGreen',
  LightTeal = 'LightTeal',
  LightBlue = 'LightBlue',
  LightNavy = 'LightNavy',
  LightPurple = 'LightPurple',
}

export enum TaskResourceIntervals {
  EveryDay = 0,
  EveryMonday = 1,
  FirstWeek = 2,
  SecondWeek = 3,
  Custom = 4,
}

export enum FormFieldType {
  textField = 1,
  numberField = 2,
  checkBox = 3,
  datePicker = 4,
  textArea = 5,
  dateTime = 6,
  fileUpload = 7,
  timePicker = 8,
  radio = 9,
  checkBoxList = 10,
  selectField = 11,
  title = 12,
  richText = 13,
  instructionImage = 14,
  instructionFile = 15,
  checklist = 16,
}

export enum DialogContextType {
  localityContext = 'locality-context-dialog',
  serviceStationContext = 'service-station-context-dialog',
  customerAdminContext = 'customer-admin-context-dialog',
  storageContext = 'storage-context-dialog',
  projectContext = 'project-context-dialog',
}

export enum FacilityTypes {
  client = 0,
  locality = 1,
  localityGroup = 2,
  serviceStation = 3,
  serviceStationGroup = 4,
  storage = 5,
  ProjectPlanning = 7, // Syncing with the backend enum value
}

export enum RoleTypes {
  Client = 0,
  Locality = 1,
  ServiceStation = 2,
  Storage = 3,
  ProjectPlanning = 4,
}

export enum MainComponentStatus {
  Active = 0,
  Incoming = 1,
  InService = 2,
  InStock = 3, // Accepted
  Outgoing = 4, // Sent to Locality
  NewlyRegistered = 5,
  OutDated = 6,
  Inactive = 7,
  InLocalityStock = 8,
  ReadyToDelivery = 9,
  InStorage = 99, // Used for filtering purpose only
}

export enum MovementType {
  SendToLocality = 0,
  SendToServiceStation = 1,
  SendToStorage = 2,
  ChangePosition = 3,
  Release = 4,
}

export enum ScheduledMaintenanceStatus {
  abandoned = 0,
  skipped = 1,
}

export enum ServiceStationType {
  ServiceStation = 0,
  Storage = 1,
  Service = 2,
}

export enum DataTypes {
  String,
  Integer,
}

export enum ControllerTypes {
  TextBox = 1,
  Dropdown = 2,
  NumberTextBox = 3,
}

export enum FunctionType {
  Min = 1,
  Max = 2,
  Average = 3,
  Sum = 4,
}

export enum TaskTypes {
  Once,
  Repeatable,
}

export enum TaskIntervals {
  Daily,
  Weekdays,
  Weekly,
  BiWeekly,
  Every3Weeks,
  Monthly,
  Bimonthly,
  Every3months,
  Every4months,
  Every6months,
  Yearly,
}

export enum Months {
  January,
  February,
  March,
  April,
  May,
  June,
  July,
  August,
  September,
  October,
  November,
  December,
}

export enum MonthShortName {
  Jan,
  Feb,
  Mar,
  Apr,
  May,
  Jun,
  Jul,
  Aug,
  Sep,
  Oct,
  Nov,
  Dec,
}

export enum IMainComponentType {
  Net = 0,
  Ring = 1,
  LiceSkirt = 2,
  Custom = 5,
}

export enum IMainComponentStatus {
  Active,
  InService,
  InStorage,
}

export enum DeviationStatus {
  Open = 0,
  InApproval = 1,
  Complete = 2,
}

export enum MaintenanceType {
  Deviation,
  Document,
  Service,
  WorkAssignment,
  Task,
  DailyMaintenance,
}

export enum IPrivilegeLevel {
  Customer,
  Admin,
  SuperAdmin,
}

export enum MooringWizardStep {
  MooringForm = 0,
  MooringComponentTemplates = 1,
  AssignTemplateToPositionDialog = 2,
  GenerateComponents = 3,
  PositionDetail = 4,
  Completed = 5,
}

export enum ReportType {
  UTLEGGSRAPPORT = 0,
  FORANKRINGINSPEKSJONSRAPPORT = 1,
  MANEDERSKONTROLL = 2,
  ARSKONTROLL = 3,
}

export enum WorkAssignmentReportTypes {
  UTLEGGSRAPPORT = 1,
  FORANKRINGINSPEKSJONSRAPPORT = 2,
  TWELVEMANEDERSKONTROLL = 5,
  SIXMANEDERSKONTROLL = 6,
  FIVEARSKONTROLL = 7,
}

export enum CoordinateMethod {
  ROV = 0,
  Diver = 1,
  Vessel = 2,
  HandheldGPS = 3,
}

export enum CoordinateSource {
  Manual = 0,
  Olex = 1,
}

export enum BottomFasten {
  Anchor = 0,
  Bolt = 1,
}

export enum Sediment {
  Mountain = 0,
  Clay = 1,
  Sandy = 2,
  SandAndStone = 3,
}

export enum ConfirmationStatus {
  Null = -1,
  Yes = 1,
  No = 0,
}

export enum DocumentViewMode {
  Category,
  List,
}

export enum MooringViewMode {
  DashBoard,
  List,
}

export enum FileType {
  PDF = 'application/pdf',
  DOC = 'doc',
}

export enum PositionViewMode {
  Map,
  List,
}

export enum MapViewMode {
  Map,
  TechnicalDrawing,
}

export enum MaintenanceViewMode {
  GroupByEquipment,
  GroupByCage,
  ShowAll,
}

export enum CertificationValidationPeriod {
  NA = -1,
  LOW = 8.3,
  MEDIUM = 49,
  HIGH = 100,
}

export enum ServiceCardInfoType {
  future,
  previous,
}

export enum DocumentExpirationType {
  None,
  Expired,
  Expiring,
  NoneExpired,
}

export enum BaseActivityType {
  Recorded = 1,
  Updated = 2,
  Deleted = 3,
  StockActivity = 4,
  SendToLocality = 5,
  RemoveFromCage = 6,
  SendToServiceStation = 7,
  ServicePerformed = 8,
  ReceivedFromService = 9,
  Certified = 10,
  CertificationExpired = 11,
  AddDeviation = 12,
  Impregnation = 13,
  Washing = 14,
  DiverControl = 15,
  ManuallyCorrected = 16,
  ExtensionOfCertification = 17,
  FormRegistered = 18,
  RelocationOfResource = 19,
  ChangedOwner = 21,
  Note = 22,
  ReferenceChange = 23,
  AttachedToCage = 25,
  AddDocument = 26,
  PerformMaintenance = 27,
  SendToStorage = 28,
  ForceSendToLocality = 29,
  MoveToAcceptedStatus = 30,
  MoveToInServiceStatus = 31,
  MoveToReadyToDeleveryStatus = 32,
  UpdatedDeviation = 33,
  DeletedDeviation = 34,
  AddDeviationFollowUp = 35,
  DeleteDeviationFollowUp = 36,
  DeviationClosed = 37,
  DocumentDeleted = 38,
  DocumentUpdated = 39,
  AddROVVideo = 40,
  FormDeleted = 41,
  WashingReportUpdated = 42,
  DeleteCertificate = 43,
  ImpregnationUpdated = 44,
  ImpregnationDeleted = 45,
  WashingReportDeleted = 46,
  ChangedCage = 47,
  DeleteROVVideo = 48,
  UpdatedROVVideoCategory = 49,
  FormMovedOut = 53,
  FormMovedIn = 54,
  DeviationMovedOut = 55,
  DeviationMovedIn = 56,
  MoveROVVideoOut = 57,
  MoveROVVideoIn = 58,
}

export enum CustomActivityType {
  Recorded = 1,
  MovingFish = 20,
  DeLiceRemoval = 24,
}

export const ActivityType = {
  ...BaseActivityType,
  ...CustomActivityType,
}

export enum ActivityLogOriginKey {
  ServiceStation,
  Cage,
  Locality,
  ForCage,
  FromLocality,
  FromStorage,
  None,
  FromServiceStation,
  Owner,
}

export enum ActivityLogReferenceKey {
  Deviation,
  Document,
  Task,
  ServiceStation,
  Cage,
  Locality,
  ForCage,
  ToStorage,
  Maintenance,
  None,
  Certification,
  ROVVideo,
  Cloned,
  Owner,
  Equipment,
}

export enum CertificateValidityPeriod {
  oneYear = 1,
  twoYear = 2,
  threeYear = 3,
  EighteenMonths = 4,
  Custom = 5,
  TwentyYears = 6,
}

export enum MaintenanceTemplateType {
  Locality = 0,
  Equipment = 1,
}

export enum RepeatType {
  Never,
  Daily,
  Weekly,
  Monthly,
  Yearly,
}

export enum ScheduledMaintenanceType {
  Locality = 0,
  Equipment = 1,
}

export enum ComponentPlacementType {
  Lifted,
  Sunk,
}

export enum ComponentInsertionStrategy {
  Replace = 0,
  InsertAndShift = 1,
  AddWithSamePosition = 2,
}

export enum SystemReportTypes {
  DeviationReport = 3,
  EquipmentReport = 6,
  EquipmentReportByClient = 8,
  EquipmentTypeReport = 10,
}

export enum ImpregnationType {
  Ubehandlet,
  E5Greenline,
  AquaNetNorthSeaUltra,
  Duranet,
  ViCote,
  AquaNetNorthSeaStandard,
  NetCoatingSort,
  EnCoatProtect,
  AquaNetProtect,
  NetwaxNl3,
  NetwaxNlGold,
  NetPolishNPQuick,
  NotoriousCoating,
  AquaNetB30,
  AquaNetB45,
  AquaNetProtectOkerGul,
  NetPolishNP30Std,
  RespectE2,
  RespectE3Hybrid,
  RespectE1Hybrid,
  NetrexAF,
  LG360no,
  Nl5,
  E8Greenline,
}

export enum ROVVideoStatus {
  Transcoding,
  Available,
}

export enum NewsType {
  General = 0,
  SystemUpdate = 1,
  Maintenance = 2,
  Safety = 3,
  Regulation = 4,
}

export enum ReportTemplateStatus {
  Active,
  Warning,
  Draft,
  Inactive,
}

export enum ReportTemplateLocation {
  WorkOrder,
  Equipment,
  Locality,
  Service,
  Deviation,
}

export enum ReportTemplateFilterBy {
  FormSchemaName,
  TemplateName,
}

export enum PositionMblType {
  Rope,
  Steel,
}

export enum WorkType {
  Splice,
  CutChain,
  Other,
}

export enum ProjectQuotationType {
  EXCEL,
  PDF,
  WORD,
}

export enum CreateCustomerOption {
  PickExistingCustomer = 'pick-existing-customer',
  CreateNewCustomer = 'create-new-customer',
}

export enum CreateLocalityOption {
  PickExistingLocality = 'pick-existing-locality',
  CreateNewLocality = 'create-new-locality',
}

export enum CustomerCompanyType {
  AS = 'AS',
  ASA = 'ASA',
}

export enum ProjectType {
  Barge = 'Flåte ',
  Other = 'Anlegg ',
}
export enum ProductCategoryFilterType {
  IsFilterByCount = 1,
  IsCheckExist = 2,
}

export enum ReportGroupingMode {
  ByProduct = 0,
  ByPositionAndProduct = 1,
}

export enum GlobalDocumentType {
  Equipment,
  Locality,
  AdminLocality,
}
